import React from 'react';
import { FileText, Plus } from 'lucide-react';
import { SharedLink } from '@/types';
import { Input } from '@/components/ui/input';
import { LinkActions } from './components/LinkActions';

interface LinkItemProps {
  link: SharedLink;
  isAdmin: boolean;
  isNew: boolean;
  onToggleStatus: () => void;
  onDelete: () => void;
  onCopy: () => void;
  copiedLinkId: string | null;
}

export function LinkItem({
  link,
  isAdmin,
  isNew,
  onToggleStatus,
  onDelete,
  onCopy,
  copiedLinkId,
}: LinkItemProps) {
  const getLinkIcon = (type: string) => {
    switch (type) {
      case 'add':
        return <Plus className="h-5 w-5" />;
      case 'info':
        return <FileText className="h-5 w-5" />;
      default:
        return null;
    }
  };

  const getLinkTypeName = (type: string) => {
    switch (type) {
      case 'add':
        return 'رابط إضافة مولود';
      case 'info':
        return 'رابط إضافة من أنت';
      default:
        return '';
    }
  };

  const getLinkUrl = (link: SharedLink) => {
    const baseUrl = window.location.origin;
    const path = link.type === 'add' ? 'add' : 'info';
    return `${baseUrl}/shared/${path}/${link.token}`;
  };

  return (
    <div
      className={`p-4 flex flex-col lg:flex-row lg:items-center gap-4 transition-all duration-300 ${
        isNew ? 'border-2 border-primary rounded-lg' : ''
      }`}
    >
      <div className="flex items-start lg:items-center flex-1">
        <span className={`flex-shrink-0 h-10 w-10 rounded-full ${
          link.isActive ? 'bg-green-100' : 'bg-gray-100'
        } flex items-center justify-center`}>
          {getLinkIcon(link.type)}
        </span>
        <div className="mr-4">
          <h3 className="text-sm font-medium text-gray-900">
            {getLinkTypeName(link.type)}
          </h3>
          <div className="text-sm text-gray-500 space-y-1">
            <p>تاريخ الإنشاء: {new Date(link.createdAt).toLocaleDateString('ar-SA')}</p>
            {link.lastUsed && (
              <p>آخر استخدام: {new Date(link.lastUsed).toLocaleDateString('ar-SA')}</p>
            )}
            <p>عدد الاستخدامات: {link.useCount}{link.maxUses ? `/${link.maxUses}` : ''}</p>
            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
              link.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
            }`}>
              {link.isActive ? 'نشط' : 'غير نشط'}
            </span>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 lg:w-[450px]">
        <div className="flex-1 min-w-0">
          <Input
            type="text"
            readOnly
            value={getLinkUrl(link)}
            className={`${
              link.isActive ? 'bg-white' : 'bg-gray-50 text-gray-500'
            }`}
          />
        </div>
        <LinkActions
          link={link}
          isAdmin={isAdmin}
          onToggleStatus={onToggleStatus}
          onDelete={onDelete}
          onCopy={onCopy}
          copiedLinkId={copiedLinkId}
        />
      </div>
    </div>
  );
}